import { render, staticRenderFns } from "./recommendAudit.vue?vue&type=template&id=2a54949c&scoped=true&"
import script from "./recommendAudit.vue?vue&type=script&lang=ts&"
export * from "./recommendAudit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a54949c",
  null
  
)

export default component.exports